export function deepEqual<T>(a: T, b: T, d = 0): boolean {
  if (d >= 1000) {
    return false;
  }

  if (a === b) {
    return true;
  }

  if (a === null || a === undefined || b === null || b === undefined) {
    return false;
  }

  if (typeof a !== "object" && typeof b !== "object") {
    return false;
  }

  const propsA = Object.keys(Object.getOwnPropertyDescriptors(a)) as (keyof T)[];
  const propsB = Object.keys(Object.getOwnPropertyDescriptors(a)) as (keyof T)[];

  if (propsA.length !== propsB.length) {
    return false;
  }

  return propsA.every((prop) => deepEqual(a[prop] as unknown, b[prop], d + 1));
}
